export default (params) => ({
  trigger: {
    name: 'content_blocks.text_image_video.show',
    params: params,
  },
  config: {
    schema: {
      title: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'text',
          'text_and_image',
          'text_and_image_two_column',
          'text_and_image_three_column',
          'text_and_video',
          'video',
          'text_personalized',
          'text_and_image_personalized',
          'text_and_image_two_column_personalized',
          'text_and_image_three_column_personalized',
          'text_and_video_personalized',
          'video_personalized',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_content_block',
    },
    nonInt: true,
  },
});
